/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreatePaymentScheduleRequest,
  CreatePaymentScheduleResponse,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Create a new payment schedule for an account.
 */
export const updatePaymentSchedule = (
  billingAccountId: number,
  createPaymentScheduleRequest: CreatePaymentScheduleRequest,
  options?: SecondParameter<
    typeof backofficeRequest<CreatePaymentScheduleResponse>
  >,
) => {
  return backofficeRequest<CreatePaymentScheduleResponse>(
    {
      url: `/api/v1/accounts/${billingAccountId}/update_payment_schedule`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createPaymentScheduleRequest,
    },
    options,
  )
}
export type UpdatePaymentScheduleResult = NonNullable<
  Awaited<ReturnType<typeof updatePaymentSchedule>>
>
